export default __webpack_public_path__ + "static/media/Filter-white.21797633.svg";